export const totalRowInstrument = "Total";
